import { Box, createTheme } from "@mui/material";
import React from "react";

export const colorBase = "#a0a0a0";
export const colorBlue = "#0265F4";
export const colorBlueDark = "#001949";
export const colorRed = "#F54F64";
export const colorGrey = "#73757A";

export const colorWhite = `#f8f9f9`;
export const colorBlack = `#3F3F3F`; // #3F3F3F
export const colorApp = `#52582d`; // # 4b5320
export const colorBg = `rgb(254, 249, 231)`;

// import { ReactComponent as SomeName } from "./SomeName.svg";
export const SvgComponent = ({ svg, sx = {}, style = {} }) => {
  const editedIcon = React.cloneElement(svg, {
    style: {
      width: "100%",
      height: "100%",
      ...style,
    },
  });
  return <Box sx={{ ...sx }}>{editedIcon}</Box>;
};
/*
USAGE:
  <SvgComponent
    svg={<Logo />}
    sx={{
      width: { xs: "300px", sm: "400px" },
      height: { xs: "300px", sm: "400px" },
    }}
  />
*/

export const textStyle = { fontSize: "15px", fontWeight: 500 };
export const smTitleStyle = { fontSize: "18px", fontWeight: 600 };
export const titleStyle = { fontSize: "28px", fontWeight: 700 };

const breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
};

const themeData = {
  breakpoints: {
    values: breakpoints,
  },
  palette: {
    primary: {
      main: `${colorBase}`,
      light: `${colorBase}`,
      dark: `${colorBase}`,
      contrastText: "#fff",
    },
    secondary: {
      light: "#ff6333",
      main: "#ff3d00",
      dark: "#b22a00",
      contrastText: "#fff",
    },
    error: {
      light: colorBase,
      main: colorBase,
      dark: colorBase,
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          text: "p",
          title: "h1",
        },
      },
      styleOverrides: {
        root: ({ ownerState }) => ({
          textTransform: "none",
          ...(ownerState.variant === "text" && {
            fontSize: "13px",
            lineHeight: "15px",
          }),
        }),
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({}),
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          padding: 0,
        }),
      },
    },
  },
  typography: {
    fontFamily: `"Work Sans"`,
    useNextVariants: true,
  },
};

export const theme = createTheme(themeData);
